import axios from 'axios';
import { Paged } from '@/shared/pagination/pageable-types';
import { BatchFile } from '@/payee-admin/batch-upload/batch-file.model';
import { API, Auth } from 'aws-amplify';
import { PaginationParameters } from '@/shared/pagination/pagination.composable';
import { BatchDetail } from '@/payee-admin/batch-upload/batch-detail.model';

export function useBatchUpload() {
  return {
    postFile,
    getBatches,
    downloadTemplate,
    getBatchErrors,
  }
}

async function postFile(file: File, payeeId: string): Promise<BatchFile> {
  const formData = new FormData();
  formData.append('file', file, file.name);

  // NOTE: Currently AWS Amplify API does not support FormData, so axios is used here directly.
  const session = await Auth.currentSession();
  const token = session.getAccessToken().getJwtToken();
  const url = process.env.VUE_APP_API_SERVER + `/v1/payees/${payeeId}/batchInvoices`;

  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  });
}

async function getBatches(payeeId: string, queryStringParameters?: PaginationParameters<BatchFile>): Promise<Paged<BatchFile>> {
  const init = queryStringParameters ? { queryStringParameters } : {};
  return API.get('API', `/v1/payees/${payeeId}/batchInvoices`, init);
}

async function getBatchErrors(
  payeeId: string,
  batchId: string,
  queryStringParameters?: PaginationParameters<BatchFile>
): Promise<Paged<BatchDetail>> {
  const errorFilter =  { status: 'ERROR' };
  const initialParams = queryStringParameters ?? {};
  const init = { queryStringParameters: { ...errorFilter, ...initialParams } };
  return API.get('API', `/v1/payees/${payeeId}/batchInvoices/${batchId}/invoiceRequests`, init);
}

function downloadTemplate() {
  const element = document.createElement('a');
  const csvContent = 'Invoice Id*,Account Id*,First Name*,Last Name*,Amount*,Phone Number,Email';
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csvContent));
  element.setAttribute('download', 'upload-template.csv');

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}
